import { useMutation } from '@tanstack/react-query';

import { registerInfoApi } from '../api';

export default function useUserDetailsMutation(config?: any) {
  return useMutation(registerInfoApi, config);
}
